var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgErlebeHertz = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 13,
  height: 14,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#erlebe-hertz_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 1.224,
  d: "M.975 13.215H11.55"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12.31 3.61a3.148 3.148 0 0 0-6-1.29 3.148 3.148 0 0 0-6 1.29 3.14 3.14 0 0 0 1.112 2.383l4.79 4.737a.14.14 0 0 0 .105.044.15.15 0 0 0 .108-.044l4.967-4.914a3.1 3.1 0 0 0 .918-2.207"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "erlebe-hertz_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.31.483h12v13.345h-12z"
})))));
export default SvgErlebeHertz;